<div class="pricing-container">
  <div class="heading">What are you going to pay us?</div>
  <div class="sub-heading">Technical talent is already expensive. Technical assessments shouldn't be.</div>
  <div class="pricing-details">
    <div class="plan-toggle-btn-sec">
      <div class="point-dis">{{ discountLabel }}</div>
      <div class="sub-title">All-in-one plan with all features included - AI question generation, coding assessments,
        automated invitations, and analytics.</div>
      <mat-radio-group aria-label="Select an option" [(ngModel)]="pos" class="m-y-btn-switch"
        (change)="monthYearlyToggle();">
        <mat-radio-button value="MONTHLY">MONTHLY</mat-radio-button>
        <mat-radio-button value="YEARLY">YEARLY</mat-radio-button>
      </mat-radio-group>
      <div [@posX]="pos" (@posX.done)="pos2=pos" class="active-item">{{pos2}}</div>
    </div>
    <div class="plan-card desktop-plan-card">
      <div class="discount-ribbon"
        *ngIf="discountedPayableMinor !== null && originalAmountMinor !== null && discountedPayableMinor < originalAmountMinor">
        {{ discountLabel || 'Limited time offer' }}
      </div>
      <div>
        <ng-container
          *ngIf="discountedPayableMinor !== null && originalAmountMinor !== null && discountedPayableMinor < originalAmountMinor; else normalPrice">
          <span class="plan-amount plan-amount--strike">
            {{ (originalAmountMinor / minorUnitDivisor) | currency:(prices?.currency || 'INR') : 'symbol' : '1.0-0' }}
          </span>
          <span class="plan-amount plan-amount--payable">
            {{ (discountedPayableMinor / minorUnitDivisor) | currency:(prices?.currency || 'INR') : 'symbol' : '1.0-0'
            }}
          </span>
          <span class="plan-savings" *ngIf="originalAmountMinor - discountedPayableMinor > 0">
            You save {{ ((originalAmountMinor - discountedPayableMinor) / minorUnitDivisor) | currency:(prices?.currency
            || 'INR') : 'symbol' : '1.0-0' }}
          </span>
        </ng-container>
        <ng-template #normalPrice>
          <span class="plan-amount">
            {{ ((prices?.amount || 0) / minorUnitDivisor) | currency:(prices?.currency || 'INR') : 'symbol' : '1.0-0' }}
          </span>
        </ng-template>
        <sub class="plan-duration">/ {{pos === 'YEARLY' ? 'Year' : 'Month'}}</sub>
      </div>
      <div class="plan-type">{{pos === 'YEARLY' ? 'Annual Plan' : 'Monthly Plan'}}</div>
      <div class="point">
        <mat-icon class="tick">check_circle</mat-icon>
        <span>AI-powered question generation and comprehensive assessment tools</span>
      </div>
      <div class="point">
        <mat-icon class="tick">check_circle</mat-icon>
        <span>Automated invitations via email and WhatsApp with custom branding</span>
      </div>
      <div class="point">
        <mat-icon class="tick">check_circle</mat-icon>
        <span>Coding assessments with 13+ programming languages and detailed analytics</span>
      </div>
      <div class="point">
        <mat-icon class="tick">check_circle</mat-icon>
        <span>7-day full refund policy if you're not satisfied with the service</span>
      </div>
      <button mat-fab extended color="warn" (click)="buyNow(prices?.planId)" class="choose-plan-btn">
        {{ userDetails ? 'Choose Plan' : 'Login / Signup' }}
      </button>
    </div>
  </div>

  <div class="plan-card mobile-plan-card">
    <div>
      <ng-container
        *ngIf="discountedPayableMinor !== null && originalAmountMinor !== null && discountedPayableMinor < originalAmountMinor; else normalPriceM">
        <span class="plan-amount plan-amount--strike">
          {{ (originalAmountMinor / minorUnitDivisor) | currency:(prices?.currency || 'INR') : 'symbol' : '1.0-0' }}
        </span>
        <span class="plan-amount plan-amount--payable">
          {{ (discountedPayableMinor / minorUnitDivisor) | currency:(prices?.currency || 'INR') : 'symbol' : '1.0-0' }}
        </span>
        <span class="plan-savings" *ngIf="originalAmountMinor - discountedPayableMinor > 0">
          Save {{ ((originalAmountMinor - discountedPayableMinor) / minorUnitDivisor) | currency:(prices?.currency ||
          'INR') : 'symbol' : '1.0-0' }}
        </span>
      </ng-container>
      <ng-template #normalPriceM>
        <span class="plan-amount">
          {{ ((prices?.amount || 0) / minorUnitDivisor) | currency:(prices?.currency || 'INR') : 'symbol' : '1.0-0' }}
        </span>
      </ng-template>
      <sub class="plan-duration">/ {{pos === 'YEARLY' ? 'Year' : 'Month'}}</sub>
    </div>
    <div class="plan-type">{{pos === 'YEARLY' ? 'Annual Plan' : 'Monthly Plan'}}</div>
    <div class="point">
      <mat-icon class="tick">check_circle</mat-icon>
      <span>AI-powered question generation and comprehensive assessment tools</span>
    </div>
    <div class="point">
      <mat-icon class="tick">check_circle</mat-icon>
      <span>Automated invitations via email and WhatsApp with custom branding</span>
    </div>
    <div class="point">
      <mat-icon class="tick">check_circle</mat-icon>
      <span>Coding assessments with 13+ programming languages and detailed analytics</span>
    </div>
    <div class="point">
      <mat-icon class="tick">check_circle</mat-icon>
      <span>7-day full refund policy if you're not satisfied with the service</span>
    </div>
    <button mat-fab extended color="warn" (click)="buyNow(prices?.planId)" class="choose-plan-btn">
      {{ userDetails ? 'Choose Plan' : 'Login / Signup' }}
    </button>
  </div>